import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { LabelText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardNoticeLabel = (props: Props) => {
  const { children, style, ...restProps } = props;

  const { match } = useResponsive();

  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM]),
  ];

  return (
    <View style={containerStyles}>
      <LabelText
        sizeMatch={['10', '12']}
        style={[styles.text, style]}
        {...restProps}
      >
        {children}
      </LabelText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
    backgroundColor: theme.colors.PEACH,
    marginHorizontal: 'auto',
  },
  containerXS: {
    borderRadius: theme.radius.small,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['1'],
  },
  containerSM: {
    borderRadius: theme.radius.medium,
    paddingVertical: theme.spacing['1'],
    paddingHorizontal: theme.spacing['2'],
  },
  text: {
    textAlign: 'center',
    color: theme.colors.CAUTION,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof LabelText>;
